import axios from "axios";

const resetCampaignsStore = ()=>{
  return {
    type: 'RESET_CAMPAIGNS_STORE'
  }
}

const getCampaigns = (payload) => {
  return async (dispatch, store) => {
    if (store().common.loading) {
      return;
    }
    dispatch({
      type: "TOGGLE_LOADING",
    });
    var url = "";
    if (payload.lastKey) {
      url = `${process.env.REACT_APP_API_ENDPOINT}/api/v1/campaigns?companyId=${payload.lastKey.companyId}&campaignId=${payload.lastKey._id}&recordsPerPage=${payload.recordsPerPage}`
    } else {
      url = `${process.env.REACT_APP_API_ENDPOINT}/api/v1/campaigns?recordsPerPage=${payload.recordsPerPage}`
    }
    const response = await axios
      .get(url)
      .catch((e) => {
        dispatch({
          type: "TOGGLE_LOADING",
        });
      });
    if (response && response.data) {
      dispatch({
        type: "TOGGLE_LOADING",
      });
      if (!response.data.success) {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "ERROR",
          },
        });
      } else {
        var lastKey = response.data.data.lastKey;
        if (response.data.data.campaigns.length === 0) {
          lastKey = null;
        }
        if (!store().campaigns.campaignList || store().campaigns.campaignList.length === 0) {
          dispatch({
            type: "SET_CAMPAIGNS",
            payload: {
              campaigns: response.data.data.campaigns,
              lastKey: lastKey,
              initialCall: false
            }
          });
        } else {
          dispatch({
            type: "SET_CAMPAIGNS",
            payload: {
              campaigns: store().campaigns.campaignList.concat(response.data.data.campaigns),
              lastKey: lastKey,
              initialCall: false
            }
          });
        }
      }
    }
  };
};

const updateCampaignInfo = (payload) => {
  return {
    type: "SET_CAMPAIGN_INFO",
    payload,
  };
};

const updateCampaign = (payload) => {
  return async (dispatch, store) => {
    if (store().common.loading) {
      return;
    }
    dispatch({
      type: "TOGGLE_LOADING",
    });
    const campaign = store().campaigns.campaign;
    const form = new FormData();
    form.set("name", campaign.name || "");
    form.set("startDate", campaign.startDate || "");
    form.set("endDate", campaign.endDate || "");
    form.set("status", campaign.status || "");
    form.set("redemptionInstructions", campaign.redemptionInstructions || "");
    form.set("terms", campaign.terms || "");
    form.set("multiScan", campaign.multiScan || (0));
    const response = await axios
      .put(
        `${process.env.REACT_APP_API_ENDPOINT}/api/v1/campaign/${payload.id}`,
        form,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .catch((e) => {
        dispatch({
          type: "TOGGLE_LOADING",
        });
      });
    if (response && response.data) {
      dispatch({
        type: "TOGGLE_LOADING",
      });
      if (!response.data.success) {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "ERROR",
          },
        });
      } else {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "INFO",
          },
        });
        payload.cb();
      }
    }
  };
};

const createCampaign = (cb) => {
  return async (dispatch, store) => {
    if (store().common.loading) {
      return;
    }
    dispatch({
      type: "TOGGLE_LOADING",
    });
    const campaign = store().campaigns.campaign || {};
    const form = new FormData();
    form.set("name", campaign.name || "");
    form.set("redemptionInstructions", campaign.redemptionInstructions || "");
    form.set("startDate", campaign.startDate || "");
    form.set("endDate", campaign.endDate || "");
    form.set("terms", campaign.terms || "");
    form.set("status", campaign.status || "");
    form.set("redemptionType", campaign.redemptionType || "");
    form.set("multiScan", campaign.multiScan || (0));
    if (campaign.redemptionType === "offline") {
      form.set("redemptionLocation", campaign.redemptionLocation || "");
    }

    const response = await axios
      .post(`${process.env.REACT_APP_API_ENDPOINT}/api/v1/campaign`, form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .catch((e) => {
        dispatch({
          type: "TOGGLE_LOADING",
        });
      });
    if (response && response.data) {
      dispatch({
        type: "TOGGLE_LOADING",
      });
      if (!response.data.success) {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "ERROR",
          },
        });
      } else {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "INFO",
          },
        });
        cb();
      }
    }
  };
};

const getCampaignInfo = (id) => {
  return async (dispatch, store) => {
    if (store().common.loading) {
      return;
    }
    dispatch({
      type: "TOGGLE_LOADING",
    });
    const response = await axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}/api/v1/campaign/${id}`)
      .catch((e) => {
        dispatch({
          type: "TOGGLE_LOADING",
        });
      });
    if (response && response.data) {
      dispatch({
        type: "TOGGLE_LOADING",
      });
      if (!response.data.success) {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "ERROR",
          },
        });
      } else {
        dispatch({
          type: "SET_CAMPAIGN",
          payload: response.data.data,
        });
      }
    }
  };
};

export default {
  getCampaigns,
  updateCampaignInfo,
  createCampaign,
  getCampaignInfo,
  updateCampaign,
  resetCampaignsStore
};
